import React from 'react';

const ClearFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M14.5 10C14.7813 10 15 10.2188 15 10.5V14.5C15 14.75 14.7812 15 14.5 15C14.25 15 14 14.75 14 14.5V11.5938C12.7812 13.625 10.5625 15 8 15C4.15625 15 1 11.8437 1 8C1 4.125 4.15625 1 8 1C10.5 1 12.6875 2.28125 13.9375 4.25C14.1563 4.59375 13.9063 5 13.5 5C13.3125 5 13.1563 4.875 13.0625 4.71875C12 3.09375 10.125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C10.25 14 12.1875 12.7812 13.2188 11H10.5C10.25 11 10 10.75 10 10.5C10 10.2188 10.25 10 10.5 10H14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ClearFilterIcon;
